import { getProposalContent } from 'common/api/v1/core';

import * as companySelectors from '../../companyGeneral/selectors';
import {
    FETCH_PROPOSAL_CONTENT,
    FETCH_PROPOSAL_CONTENT_SUCCESS,
    FETCH_PROPOSAL_CONTENT_FAILURE,
} from '../actionTypes';
import { multiTemplateReviewActions } from '../reducer';

export default (contentId, initTemplate) => (dispatch, getState) => {
    const companyId = companySelectors.getCompanyId(getState());
    dispatch(multiTemplateReviewActions[FETCH_PROPOSAL_CONTENT]());
    getProposalContent(contentId)
        .then((response) => {
            dispatch(
                multiTemplateReviewActions[FETCH_PROPOSAL_CONTENT_SUCCESS](
                    response.data.data,
                ),
            );
            initTemplate(response.data.data, companyId);
        })
        .catch((error) =>
            dispatch(
                multiTemplateReviewActions[FETCH_PROPOSAL_CONTENT_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
